import classNames from "classnames"
import React from "react"

import { Sprinkles, sprinkles } from "@/styles/sprinkles.css"

import * as styles from "./Stack.css"

type DefinedStackVariants = NonNullable<styles.StackVariants>

type ResponsiveGap =
	| DefinedStackVariants["baseGap"]
	| {
			largeDisplay: DefinedStackVariants["largeDisplayGap"]
			smallDisplay: DefinedStackVariants["baseGap"]
	  }

export type StackProps = {
	children?: React.ReactNode
	component?: React.ElementType
	className?: string
	gap?: ResponsiveGap
} & Omit<DefinedStackVariants, "baseGap" | "largeDisplayGap"> &
	// These two properties would conflict with the stack's properties.
	// In practice box does not allow flexDirection, but we are keeping it here
	// just in case it is added later.
	Omit<Sprinkles, "display" | "flexDirection">

export function Stack({
	children,
	gap,
	className,
	direction,
	component = "div",
	...sprinkleProps
}: StackProps) {
	let baseGap = typeof gap === "string" ? gap : gap?.smallDisplay
	let largeDisplayGap = typeof gap === "string" ? undefined : gap?.largeDisplay
	return React.createElement(
		component,
		{
			className: classNames(
				styles.stack({ direction, baseGap, largeDisplayGap }),
				sprinkles(sprinkleProps),
				className,
			),
		},
		children,
	)
}
